import React from "react";
import { clsx } from "clsx";
import { Link } from "gatsby";
import { AiOutlineTag } from "react-icons/ai";

interface ITagProps extends React.PropsWithChildren {
  name: string;
  tagId: string;

  /**
   * @default false
   */
  primary?: boolean;
}

export default function Tag(props: ITagProps) {
  const { name, primary, tagId } = props;

  return (
    <Link
      className={clsx(
        "badge",
        {
          "badge-primary": primary,
        },
        "gap-x-1",
      )}
      to={`/tags/${tagId}`}
    >
      <AiOutlineTag />
      {name}
    </Link>
  );
}
